export default {
  students: [],
  student: null,
};
